<template>
  <div
    id="lp2"
    class="d-flex flex-column align-items-center justify-content-center min-vh-100"
    :class="isTribanco ? 'banner-promo-tribanco' : 'banner-promo-tricard'"
  >
    <div class="container">
      <div class="row">
        <!-- <div class="p-5 col-10 lpp col-md-5"></div> -->
          <div class="card mx-auto p-4" style="max-width: 400px; width: 100%; border-radius: 20px">
          <h5 style="color: #054375" class="mt-3">Receber código de acesso</h5>
          <p style="color: #054375" class="mb-0">
            Informe por qual canal deseja receber seu <br />
            código de acesso
          </p>
          <form
            v-on:submit="sendNewContact"
            v-on:submit.prevent
            name="contact-form"
          >
            <div class="form-group mt-3">
              <div class="px-1">
                <p class="mb-2" style="color: #054375">
                  Escolha como deseja receber o código
                </p>

                <div class="radio-row mb-1">
                  <label class="radio-choice">
                    <input
                      type="radio"
                      value="email"
                      v-model="selectedOption"
                      @change="selectRadio(1)"
                    />
                    <span class="dot"></span>
                    <span class="lbl">Por E-MAIL</span>
                  </label>

                  <label class="radio-choice">
                    <input
                      type="radio"
                      value="sms"
                      v-model="selectedOption"
                      @change="selectRadio(2)"
                    />
                    <span class="dot"></span>
                    <span class="lbl">Por SMS</span>
                  </label>
                </div>

                <!-- EMAIL -->
                <template v-if="selectedOption === 'email'">
                  <multiselect
                    v-model="form.emailSelected"
                    class="mb-2 w-100"
                    :multiple="false"
                    :select-label="'selecionar'"
                    deselect-label="remover"
                    track-by="Email"
                    label="Email"
                    placeholder="Escolha o e-mail"
                    :options="form.emailList"
                    :searchable="false"
                    :allow-empty="true"
                  >
                    <template #singleLabel="{ option }">{{
                      option.Email
                    }}</template>
                    <template #noOptions
                      >Não foi encontrado nenhum email cadastrado</template
                    >
                  </multiselect>

                  <!-- <p class="text-info mb-1">
                    Ou se preferir, informe um novo e-mail:
                  </p>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Informe um e-mail"
                    id="formEmail"
                    v-model="form.newEmail"
                    @input="typeNewEmail"
                  /> -->
                </template>

                <!-- SMS -->
                <template v-else-if="selectedOption === 'sms'">
                  <multiselect
                    v-model="form.phoneSelected"
                    class="mb-2 w-100"
                    @click="removeEquals(form)"
                    :multiple="false"
                    :select-label="'selecionar'"
                    deselect-label="remover"
                    track-by="PhoneNumber"
                    label="PhoneNumber"
                    placeholder="Escolha o telefone"
                    :options="form.phoneList"
                    :searchable="true"
                    :allow-empty="true"
                  >
                    <template #singleLabel="{ option }">{{
                      option.PhoneNumber
                    }}</template>
                    <template #noOptions
                      >Não foi encontrado nenhum telefone</template
                    >
                  </multiselect>

                  <!-- <p class="text-info mb-1">
                    Ou se preferir, informe um novo número:
                  </p>
                  <the-mask
                    type="tel"
                    class="form-control"
                    placeholder="Informe um telefone"
                    id="form9"
                    v-model="form.newPhone"
                    mask="(##) # ####-####"
                    @input="typeNewPhone"
                  /> -->
                </template>
              </div>
            </div>

            <ProgressLoading v-bind:loading="loading" />
            <button
              type="submit"
              class="btn btn-primary text-white pt-2 pb-2"
              v-if="!loading"
            >
              Receber código
            </button>
            <div class="form-group mb-3">
              <small
                class="form-text text-muted text-center mt-2"
                style="color: #054375; text-decoration: underline"
              >
                <a href="#" v-if="!loading" @click="voltar()"
                  >Lembrei meu código</a
                >
              </small>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- <div class="text-center mt-4">
      <h5 style="color: white">Renegocie suas dívidas com</h5>
      <img
        src="img/inteligencia.png"
        alt="inteligência"
        class="img-fluid"
        style="max-width: 300px"
      />
    </div> -->
  </div>
</template>

<script>
// import { TheMask } from "vue-the-mask";
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProgressLoading from "./ProgressLoading.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    ProgressLoading,
    Multiselect,
    // TheMask,
  },
  mixins: [validationMixin],
  // directives: { TheMask },
  validations: {
    form: {
      promoCode: { required, minLength: minLength(5) },
    },
  },
  data: () => ({
    form: {
      promoCode: null,
      emailSelected: [],
      phoneSelected: [],
      emailList: [],
      phoneList: [],
      newEmail: null,
      newPhone: null,
    },
    error: {
      alert: false,
      status: null,
      message: null,
    },
    loading: false,
    dialog: false,
    promoCode: null,
    sendCode: false,
    EmailOrPhone: "email",
    email: true,
    sms: false,
    code: false,
    emailDebtor: null,
    smsDebtor: null,
    infoDebtor: null,
    emailsListWithoutMask: [],
    phoneListWithoutMask: [],
    phoneNumberFinal: null,
    ipUser: null,
    selectedOption: "sms",
    envOwnerId: process.env.VUE_APP_OWNER_ID,
  }),

  telefoneErrors() {
    const errors = [];
    if (!this.$v.form.telefone.$dirty) return errors;
    !this.$v.form.telefone.minLength &&
      errors.push("Digite um Telefone válido");

    return errors;
  },

  emailErrors() {
    const errors = [];
    if (!this.$v.form.email.$dirty) return errors;
    !this.$v.form.email.email && errors.push("Digite um e-mail válido!");

    return errors;
  },
  created() {
    this.ipUser = localStorage.getItem("ipUser");
    if (typeof this.contacts.ListEmailsWithMask.Email !== "undefined") {
      this.contacts.ListEmailsWithMask.Email.map((email) => {
        this.form.emailList.push({
          Email: email,
        });
      });

      this.form.emailSelected = this.contacts.ListEmailsWithMask.Email;
    } else {
      this.form.emailSelected = "";
    }

    if (typeof this.contacts.ListPhonesWithMask.PhoneNumber !== "undefined") {
      this.contacts.ListPhonesWithMask.PhoneNumber.map((phone) => {
        this.form.phoneList.push({
          PhoneNumber: phone,
        });
      });

      this.form.phoneSelected = this.contacts.ListPhonesWithMask.PhoneNumber;
    } else {
      this.form.phoneSelected = "";
    }

    this.contacts.Emails
      ? this.emailsListWithoutMask.push({ Email: this.contacts.Emails })
      : "";
    // this.contacts.PhoneNumbers ? this.phoneListWithoutMask.push({ PhoneNumber: this.contacts.PhoneNumbers }) : '';
    // this.contacts.MobileNumbers ? this.phoneListWithoutMask.push({ PhoneNumber: this.contacts.MobileNumbers }) : '';

    this.phoneListWithoutMask.push(this.contacts.PhonesWithoutMask);
    this.removeEquals(this.form);

    // this.form.phoneSelected = this.contacts.PhoneNumbers;
  },
  computed: {
    ...mapState("auth", ["contacts"]),

    isTribanco() {
      const ownerId = this.envOwnerId;
      if (!ownerId) return false;
      if (Array.isArray(ownerId)) {
        return ownerId.map(Number).some((id) => [8, 22].includes(id));
      }
      return [8, 22].includes(Number(ownerId));
    },

    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
  },
  methods: {
    ...mapActions("auth", [
      "ActionSetCurrentForm",
      "ActionSendPromoCode",
      "ActionCreateDebtor",
      "ActionSetContacts",
    ]),

    removeEquals(form) {
      let newPhoneList = [];
      form.phoneList.map((value, key) => {
        if (!newPhoneList.includes(value.PhoneNumber))
          newPhoneList.push(value.PhoneNumber);
        else delete this.form.phoneList[key];
      });
    },

    validateEmail(email) {
      if (typeof email !== "string") return false;
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i; // sem espaços, sem @ nas partes, TLD >= 2
      return re.test(email.trim());
    },

    async sendNewContact(e) {
      this.emailFinal = null;
      this.phoneNumberFinal = null;
      var typeSent = null;

      e.preventDefault();
      this.$v.$touch();
''
      if (this.selectedOption === "email") {
        // Verifica se há email selecionado ou novo email informado
        const hasSelectedEmail = this.form.emailSelected && this.form.emailSelected.Email;
        const hasNewEmail = this.form.newEmail && this.form.newEmail.trim() !== "";

        if (!hasSelectedEmail && !hasNewEmail) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: "informe ao menos um meio de contato",
          });
          return;
        }

        // Se há um email selecionado da lista, usa ele (já validado pelo backend)
        if (hasSelectedEmail) {
          this.emailFinal = this.form.emailSelected.Email;
        } else if (hasNewEmail) {
          // Só valida se for um novo email digitado pelo usuário
          var emailValid = this.validateEmail(this.form.newEmail);
          if (!emailValid) {
            this.flashMessage.show({
              timeout: 1000,
              status: "error",
              title: "Ocorreu um erro",
              message: "Informe um email válido!",
            });
            this.loading = false;
            return;
          }
          this.emailFinal = this.form.newEmail;
        }

        typeSent = "email";
      }

      if (this.selectedOption === "sms") {
        if (!this.form.newPhone && !this.form.phoneSelected.PhoneNumber) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: "informe ao menos um meio de contato",
          });
          return;
        }

        typeSent = "sms";
      }

      console.log(
        "this.form.phoneSelected: " + JSON.stringify(this.form.phoneSelected)
      );
      console.log("this.form.newPhone: " + JSON.stringify(this.form.newPhone));

      if (this.form.phoneSelected != null && this.form.phoneSelected != "") {
        this.phoneNumberFinal = this.form.phoneSelected.PhoneNumber;
      } else {
        this.phoneNumberFinal = this.form.newPhone;
      }

      localStorage.setItem("typesent", typeSent);

      this.loading = true;
      // this.telefoneErrors.pop();
      if (this.contacts.SourceInfo === "API_EXTERNA") {
        try {
          var response = await this.ActionCreateDebtor({
            FullName: this.contacts.FullName ? this.contacts.FullName : null,
            DocNumber: this.contacts.DocNumber,
            Email: this.emailFinal,
            PhoneNumber:
              this.phoneNumberFinal != null ? this.phoneNumberFinal : null,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : "",
          });

          if (response.status === 200) {
            this.ActionSetContacts({
              DebtorID: response.data.results.DebtorID,
            });
            this.flashMessage.show({
              timeout: 300,
              status: "success",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Sucesso",
              message: "código enviado com sucesso",
            });

            this.ActionSetCurrentForm("form-promo-code");
            this.loading = false;
          } else {
            this.loading = false;
            this.error.status = "ERROR";

            this.flashMessage.show({
              timeout: 300,
              status: "error",
              position: "top right",
              blockClass: "custom-block-class",
              title: "Erro",
              message:
                "ocorreu um erro ao tentar enviar o código de acesso, tente novamente mais tarde",
            });
          }
        } catch (error) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: error.data.message,
          });

          this.error.status = "ERROR";
        }
      } else {
        console.log(
          "this.phoneNumberFinal: " + JSON.stringify(this.phoneNumberFinal)
        );
        var result = await this.ActionSendPromoCode({
          DocNumber: this.contacts.DocNumber,
          DebtorId: this.contacts.DebtorID,
          Email: this.emailFinal,
          PhoneNumber:
            this.phoneNumberFinal != null ? this.phoneNumberFinal : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        if (result.status === 500 || result.status !== 200) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Erro",
            message: result.data?.message ?? "Erro na solicitação",
          });
        } else {
          this.flashMessage.show({
            timeout: 300,
            status: "success",
            position: "top right",
            blockClass: "custom-block-class",
            title: "Sucesso",
            message: "código enviado com sucesso",
          });

          this.ActionSetCurrentForm("form-promo-code");
        }
      }
      this.loading = false;
      // }
    },

    //     async sendNewContact(e) {
    //   this.emailFinal = null;
    //   this.phoneNumberFinal = null;

    //   e.preventDefault();
    //   this.$v.$touch();

    //   if (this.email) {
    //     if ((this.form.newEmail === null || this.form.newEmail === "") && (this.form.emailSelected === null || !this.form.emailSelected.Email)) {
    //       this.flashMessage.show({
    //         timeout: 300,
    //         status: "error",
    //         position: "top right",
    //         blockClass: "custom-block-class",
    //         title: "Erro",
    //         message: "informe ao menos um meio de contato",
    //       });
    //       return;
    //     }
    //     if (this.form.newEmail) {
    //       this.emailFinal = this.form.newEmail;
    //       } else {
    //       this.emailFinal = this.contacts.Emails[0];
    //     }
    //   }

    //   if (this.sms) {
    //     if (
    //       !this.form.newPhone &&
    //       !this.form.phoneSelected.PhoneNumber
    //     ) {
    //       this.flashMessage.show({
    //         timeout: 300,
    //         status: "error",
    //         position: "top right",
    //         blockClass: "custom-block-class",
    //         title: "Erro",
    //         message: "informe ao menos um meio de contato",
    //       });
    //       return;
    //     }

    //     if (this.form.newPhone !== null) {
    //       this.phoneNumberFinal = this.form.newPhone;
    //     } else {
    //       var chosenPhone = this.form.phoneSelected.PhoneNumber
    //         ? this.form.phoneSelected.PhoneNumber
    //         : this.form.phoneSelected;
    //       var fourLastNumbersPhone = chosenPhone.slice(chosenPhone.length - 4);
    //       var lastFourDigits = null;

    //       this.phoneListWithoutMask.map((phone) => {
    //         if (phone.PhoneNumber) {
    //           phone.PhoneNumber.map((item) => {
    //             lastFourDigits = item.slice(item.length - 4);

    //             if (lastFourDigits === fourLastNumbersPhone) {
    //               this.phoneNumberFinal = item;
    //             }
    //           });
    //         }
    //       });
    //     }
    //   }

    //   this.loading = true;
    //   // this.telefoneErrors.pop();

    //   if (this.contacts.SourceInfo === "API_EXTERNA") {
    //     try {
    //       var response = await this.ActionCreateDebtor({
    //         FullName: this.contacts.FullName ? this.contacts.FullName : null,
    //         DocNumber: this.contacts.DocNumber,
    //         Email: this.emailFinal,
    //         PhoneNumber:
    //           this.phoneNumberFinal != null
    //             ? this.phoneNumberFinal
    //                 .replace("(", "")
    //                 .replace(")", "")
    //                 .replace(" ", "")
    //                 .replace(" ", "")
    //                 .replace("-", "")
    //             : null,
    //             OS: navigator.platform,
    //             IP: this.ipUser ? this.ipUser : '',
    //       });

    //       if (response.status === 200) {
    //         this.ActionSetContacts({
    //           DebtorID: response.data.results.DebtorID,
    //         });
    //         this.flashMessage.show({
    //           timeout: 300,
    //           status: "success",
    //           position: "top right",
    //           blockClass: "custom-block-class",
    //           title: "Sucesso",
    //           message: "código enviado com sucesso",
    //         });
    //         this.ActionSetCurrentForm("form-promo-code");
    //         this.loading = false;
    //         this.clearInputsAndSelect();
    //       } else {
    //         this.loading = false;
    //         this.error.status = "ERROR";

    //         this.flashMessage.show({
    //           timeout: 300,
    //           status: "error",
    //           position: "top right",
    //           blockClass: "custom-block-class",
    //           title: "Erro",
    //           message:
    //             "ocorreu um erro ao tentar enviar o promocode, tente novamente mais tarde",
    //         });
    //         // algum status de erro
    //       }
    //     } catch (error) {
    //       // algum tratamento de erro
    //       this.flashMessage.show({
    //         timeout: 300,
    //         status: "error",
    //         position: "top right",
    //         blockClass: "custom-block-class",
    //         title: "Erro",
    //         message: error.data.message,
    //       });

    //       // this.emailErrors.push(error.data.message);
    //       this.error.status = "ERROR";
    //     }
    //   } else {
    //     var result = await this.ActionSendPromoCode({
    //       DebtorId: this.contacts.DebtorID,
    //       Email: this.emailFinal,
    //       PhoneNumber:
    //         this.phoneNumberFinal != null
    //           ? this.phoneNumberFinal
    //               .replace("(", "")
    //               .replace(")", "")
    //               .replace(" ", "")
    //               .replace(" ", "")
    //               .replace("-", "")
    //           : null,
    //           OS: navigator.platform,
    //           IP: this.ipUser ? this.ipUser : '',
    //     });

    //     if (result.status === 500) {
    //       this.flashMessage.show({
    //         timeout: 300,
    //         status: "error",
    //         position: "top right",
    //         blockClass: "custom-block-class",
    //         title: "Erro",
    //         message: result?.error?.message ?? "Erro na solicitação",
    //       });
    //     } else {
    //       this.flashMessage.show({
    //         timeout: 300,
    //         status: "success",
    //         position: "top right",
    //         blockClass: "custom-block-class",
    //         title: "Sucesso",
    //         message: "código enviado com sucesso",
    //       });

    //       this.ActionSetCurrentForm("form-promo-code");
    //     }
    //   }
    //   this.clearInputsAndSelect();
    //   this.loading = false;
    //   // }
    // },

    selectRadio(value) {
      if (value === 1) {
        this.form.newPhone = null;
        this.form.phoneSelected = "";
      } else {
        this.form.newEmail = null;
        this.form.emailSelected = "";
      }
    },

    clearInputsAndSelect() {
      this.form.newPhone = null;
      this.form.phoneSelected = "";
      this.form.newEmail = null;
      this.form.emailSelected = "";
    },

    sendCodeForm() {
      this.ActionSetCurrentForm("form-send-code");
    },
    voltar() {
      this.$destroy();
      this.ActionSetCurrentForm("form-doc-number");
    },

    typeNewEmail() {
      this.form.emailSelected = null;
    },

    typeNewPhone() {
      this.form.phoneSelected = null;
    },
  },
};
</script>
<style>
/* Tribanco: fundo original do passo “receber código” (antes era único para todas as marcas) */
.banner-promo-tribanco {
  background-image: url("/img/background-tricard-login.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px;
}

/* Tricard: banner portal Tricard */
.banner-promo-tricard {
  background-image: url("/img/banner-outubro-2025.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px;
}

@media (max-width: 500px) {
  .banner-promo-tricard {
    background-image: url("/img/banner-outubro-2025-mobile.jpg");
    background-position: top center;
    justify-content: flex-start;
    padding: calc(64px + env(safe-area-inset-top, 0px) + 6px) 12px 20px;
    min-height: 100dvh;
    min-height: 100vh;
    box-sizing: border-box;
  }
}

.multiselect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 35px;
  background: #fff;
  display: block;
}
.multiselect__spinner:before,
.multiselect__spinner:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41b883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent;
}
.multiselect__spinner:before {
  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.multiselect__spinner:after {
  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.multiselect__loading-enter,
.multiselect__loading-leave-active {
  opacity: 0;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-family: inherit;
  font-size: 14px;
  touch-action: manipulation;
}
.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  min-height: 40px;
  text-align: left;
  color: #35495e;
}
.multiselect * {
  box-sizing: border-box;
}
.multiselect:focus {
  outline: none;
}
.multiselect--disabled {
  pointer-events: none;
  opacity: 0.6;
}
.multiselect--active {
  z-index: 50;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.multiselect--active .multiselect__select {
  transform: rotateZ(180deg);
}
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.multiselect__input,
.multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  background: #fff;
  padding: 1px 0 0 5px;
  width: calc(100%);
  transition: border 0.1s ease;
  box-sizing: border-box;
  margin-bottom: 8px;
  vertical-align: top;
}
.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
  width: auto;
}
.multiselect__input:hover,
.multiselect__single:hover {
  border-color: #cfcfcf;
}
.multiselect__input:focus,
.multiselect__single:focus {
  border-color: #a8a8a8;
  outline: none;
}
.multiselect__single {
  padding-left: 6px;
  margin-bottom: 8px;
}
.multiselect__tags-wrap {
  display: inline;
}
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: initial;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all 0.2s ease;
  border-radius: 5px;
}
.multiselect__tag-icon:after {
  content: "×";
  color: #266d4d;
  font-size: 14px;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #369a6e;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: white;
}
.multiselect__current {
  line-height: 16px;
  min-height: 40px;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  margin: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  cursor: pointer;
}
.multiselect__select {
  line-height: 16px;
  display: block;
  position: absolute;
  box-sizing: border-box;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  margin: 0;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.multiselect__select:before {
  position: relative;
  right: 0;
  top: 65%;
  color: #999;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  border-color: #03659b transparent transparent transparent;
  content: "";
}
.multiselect__placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
.multiselect--active .multiselect__placeholder {
  display: none;
}
.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 50;
  -webkit-overflow-scrolling: touch;
}
.multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
}
.multiselect--above .multiselect__content-wrapper {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
}
.multiselect__content::webkit-scrollbar {
  display: none;
}
.multiselect__element {
  display: block;
}
.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}
.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
}
.multiselect__option--highlight {
  background: #41b883;
  outline: none;
  color: white;
}
.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #41b883;
  color: white;
}
.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
  font-weight: bold;
}
.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}
.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  background: #ededed;
  color: #a6a6a6;
}
.multiselect__option--disabled {
  background: #ededed;
  color: #a6a6a6;
  cursor: text;
  pointer-events: none;
}
.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede !important;
}
.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}
.multiselect__strong {
  margin-bottom: 10px;
  display: inline-block;
}
*[dir="rtl"] .multiselect {
  text-align: right;
}
*[dir="rtl"] .multiselect__select {
  right: auto;
  left: 1px;
}
*[dir="rtl"] .multiselect__tags {
  padding: 8px 8px 0px 40px;
}
*[dir="rtl"] .multiselect__content {
  text-align: right;
}
*[dir="rtl"] .multiselect__option:after {
  right: auto;
  left: 0;
}
*[dir="rtl"] .multiselect__clear {
  right: auto;
  left: 12px;
}
*[dir="rtl"] .multiselect__spinner {
  right: auto;
  left: 1px;
}
@keyframes spinning {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(2turn);
  }
}

.radio-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.radio-choice {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

/* esconde o input nativo */
.radio-choice input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* “anel” azul */
.radio-choice .dot {
  width: 22px;
  height: 22px;
  border: 2px solid #1f66d1;
  border-radius: 50%;
  position: relative;
  display: inline-block;
}

/* bolinha preenchida quando selecionado */
.radio-choice input:checked + .dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: #0b5fad;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

/* texto: ativo azul, inativo “apagado” */
.radio-choice .lbl {
  color: #054375;
}
.radio-choice input:not(:checked) ~ .lbl {
  color: #8a97ad;
}
</style>